document.addEventListener("DOMContentLoaded", function () {
    const clearBtn = document.querySelector("#clear-discount-btn");
    const applyBtn = document.querySelector("#apply-discount-btn");
    const discountCodeStatus = document.querySelector("#discount-code-status");
    const discountCodeInput = document.querySelector("#discount-code");
    const totalCart = document.querySelector("#CartSubtotal");

    if (applyBtn) {
        applyBtn.addEventListener("click", function (e) {
            e.preventDefault();
            const code = discountCodeInput.value.trim();
            if (code) {
                applyDiscount(code);
            }
        });
    }

    if (discountCodeInput && applyBtn) {
        discountCodeInput.addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                applyBtn.click();
            }
        });
    }

    if (clearBtn) {
        clearBtn.addEventListener("click", function (e) {
            e.preventDefault();
            this.style.display = "none";
            clearDiscount();
        });
    }

    function clearDiscount() {
        if (discountCodeStatus) discountCodeStatus.innerHTML = "";
        if (discountCodeInput) {
            discountCodeInput.value = "";
            discountCodeInput.style.border = "";
        }

        fetch(`${window.location.origin}/cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ discount: "" })
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Clear discount request failed: " + response.status);
                }
                return response.json();
            })
            .then(() => {
                window.location.reload();
            })
            .catch((err) => console.error("Error clearing discount:", err));
    }

    function applyDiscount(code) {
        if (!applyBtn) return;

        applyBtn.innerHTML = "APPLY <div class='loader'></div>";
        applyBtn.style.pointerEvents = "none";

        fetch(`${window.location.origin}/cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ discount: code })
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Apply discount request failed: " + response.status);
                }
                return response.json();
            })
            .then((cart) => {
                const discountEntry = cart.discount_codes && cart.discount_codes.find(
                    (d) => d.code.toLowerCase() === code.toLowerCase()
                );
                const applied = discountEntry && discountEntry.applicable;

                if (!applied) {
                    if (discountCodeStatus) {
                        discountCodeStatus.innerHTML = `<small class="discount-error-msg">That code isn't valid or doesn't apply to your cart.</small>`;
                    }
                    if (discountCodeInput) {
                        discountCodeInput.style.border = "1px solid red";
                    }
                    applyBtn.innerHTML = "APPLY";
                    applyBtn.style.pointerEvents = "auto";
                    return;
                }

                window.location.reload();
            })
            .catch((err) => {
                console.error("Error applying discount:", err);
                applyBtn.innerHTML = "APPLY";
                applyBtn.style.pointerEvents = "auto";
            });
    }

    console.log("Discount code script loaded");
});